/**
 * Preview — "Gäste-App ansehen" from the client-admin.
 *
 * A house that is still a draft is a 404 for guests. Its own people open it
 * through the client-admin, which mints a short-lived preview token
 * (core-api POST /accommodation/:id/preview) and hands it over as
 * `?preview=<token>`. This class takes it from the URL, keeps it for the tab
 * (sessionStorage — a reload keeps the preview, a new tab or a shared link
 * does not) and removes it from the address bar so it is not copied along.
 *
 * The token goes with every API request as `x-preview` (core/Api) and onto
 * the URLs loaded without headers (the tenant stylesheet, core/Theme). The
 * API opens exactly that house with it, as a guest sees it — never another
 * draft, never the manager's view.
 */
export class Preview
{
    static STORAGE_KEY = "belturo.guest.preview";
    static PARAM = "preview";

    constructor()
    {
        this.token = this._resolve();
    }

    /** The preview token of this tab, or null. */
    getToken()
    {
        return this.token;
    }

    /** `?preview=<token>` (or `&…` after an existing query), "" without one. */
    queryFor( url )
    {
        if ( !this.token )
        {
            return "";
        }
        return ( url.includes( "?" ) ? "&" : "?" ) + Preview.PARAM + "=" + encodeURIComponent( this.token );
    }

    _resolve()
    {
        let token = null;
        try
        {
            const url = new URL( window.location.href );
            const fromUrl = url.searchParams.get( Preview.PARAM );
            if ( fromUrl && /^[0-9a-f-]{36}$/i.test( fromUrl ) )
            {
                token = fromUrl;
                sessionStorage.setItem( Preview.STORAGE_KEY, token );
            }
            if ( url.searchParams.has( Preview.PARAM ) )
            {
                url.searchParams.delete( Preview.PARAM );
                window.history.replaceState( window.history.state, "", url.href );
            }
        }
        catch ( e ) { /* no URL API / storage: no preview */ }

        if ( !token )
        {
            try
            {
                token = sessionStorage.getItem( Preview.STORAGE_KEY ) || null;
            }
            catch ( e ) { /* storage blocked */ }
        }
        return token;
    }
}
